import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { AddPaymentContentComponent } from '../add-payment-content/add-payment-content/add-payment-content.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-item-modal',
  standalone: true,
  imports: [IconComponent, AddPaymentContentComponent, TranslatePipe],
  templateUrl: './payment-item-modal.component.html',
  styleUrl: './payment-item-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentItemModalComponent {
  public readonly iconName = IconName;
  private dialogRef = inject(MatDialogRef<PaymentItemModalComponent>);

  public modalClose(): void {
    this.dialogRef.close();
  }
}
